
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"fill":"none","height":"24","viewBox":"0 0 24 24","width":"24","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"m6.89474 18.3158c-1.04211 0-1.89474.7579-1.89474 1.6842h13.2632c0-.9263-.8527-1.6842-1.8948-1.6842h-3.7895v-1.6842h2.8422c1.0421 0 1.8947-.7579 1.8947-1.6842h-7.57896c-1.57263 0-2.8421-1.1285-2.8421-2.5263 0-.9179.55894-1.7179 1.39263-2.1643.38842.4969 1.00421.8421 1.73373.8927.6631.0505 1.2884-.16 1.7526-.5221l.5589 1.3558.8906-.2864.3221.7916 1.781-.5726-.3221-.7916.8905-.2863-2.5958-6.33264-.8905.28632-.3221-.79158-1.781.57263.3221.79158-.89056.29474.53056 1.30526c-1.10845-.03368-2.07477.63158-2.34951 1.56632-1.71473.64-2.91789 2.13897-2.91789 3.89057 0 2.3242 2.12211 4.2105 4.73684 4.2105v1.6842zm5.55156-12.19369 1.62 3.95789-.8905.2863-1.62-3.95788zm-2.2358 2.08842c.5211 0 .9474.37894.9474.8421s-.4263.84211-.9474.84211c-.52103 0-.94734-.37895-.94734-.84211s.42631-.8421.94734-.8421z","fill":"#4a3428"}})])
          )
        }
      }
    